/**
 *
 * App
 *
 */

import SharedHeader from '@/components/SharedHeader.vue';
import SharedFooter from '@/components/SharedFooter.vue';

export default {
  name: 'App',

  components: {
    SharedHeader,
    SharedFooter,
  },

  data: () => {
    return {};
  },

  mounted() {
    window.scrollTo(0, 0);
  },
};
